// extracted by mini-css-extract-plugin
export default {"footerActions":"discard-assigned-changes-modal_footerActions__05TIZ"};